import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { mergeDeepRight } from 'ramda'
import { TrackInfo, TrackInfoMap, UserChannel, UserChannelMap } from '../types'

export interface BlasterPeer {
  username: string
  isCurrentUser: boolean
  tracksInitialized: boolean
  tracks: TrackInfoMap
  ownedMatchSlug: string
  allTracksPlaylistSlug: string
  channels: UserChannelMap
}
export type BlasterPeerMap = { [key: string]: BlasterPeer }
const initialState: BlasterPeerMap = {}
const blasterPeersSlice = createSlice({
  name: 'blasterPeers',
  initialState,
  reducers: {
    initCurrentUser: (state, action) => {
      const { username, ownedMatchSlug, allTracksPlaylistSlug, playlistMap = {} } = action.payload
      const newPeer = {
        [username]: {
          username,
          isCurrentUser: true,
          tracksInitialized: false,
          tracks: {},
          playlistMap,
          ownedMatchSlug,
          allTracksPlaylistSlug,
        },
      }
      const result = mergeDeepRight(state, newPeer)
      return result
    },
    setTracks: (state, action: PayloadAction<{ username: string; tracks: TrackInfoMap }>) => {
      const { username, tracks } = action.payload
      const updatedPeer = {
        [username]: { tracks, tracksInitialized: true },
      }
      const result = mergeDeepRight(state, updatedPeer)
      return result
    },
    updateChannel: (state, action: PayloadAction<{ username: string; channel: UserChannel }>) => {
      const { username, channel } = action.payload
      const updatedPeer = {
        [username]: {
          channels: {
            default: channel,
          },
        },
      }
      const result = mergeDeepRight(state, updatedPeer)
      return result
    },
    updateTrack: (state, action: PayloadAction<{ username: string; trackInfo: TrackInfo }>) => {
      const { username, trackInfo } = action.payload
      const updatedPeer = {
        [username]: {
          tracks: {
            [trackInfo.slug]: trackInfo,
          },
        },
      }
      const result = mergeDeepRight(state, updatedPeer)
      return result
    },
  },
})

export default blasterPeersSlice
